module.exports = __webpack_public_path__ + "static/media/logo-white.6d059806.png";